const getUsersPermissions = (state) => state.usersPermissions.items;
const getUsersPermissionsLoading = (state) => state.usersPermissions.isLoading;

export { getUsersPermissions, getUsersPermissionsLoading };
